import { getBootstrap } from "@/lib/bootstrap";
import type { SiteOptions } from "@/types/global";

export function useSiteOptions(): SiteOptions {
  return getBootstrap().options;
}
